<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="dashboardPanels"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    import axios from 'axios';
    /**
     * Allows the selection of a dashboard panel ID by choosing its name
     */
    export default {
        name: 'ies-dashboardPanelKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                dashboardPanels: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getDashboards();
        },
        methods: {
            getDashboards:function(){
                axios.get('/api/dashboard-panels')
                .then(function(response){
                    var dashboardPanels = [];
                    response.data.forEach(function(record){
                        dashboardPanels.push({ text: record.system_name, value: record.dashboard_panel_key });
                    });
                    this.dashboardPanels = dashboardPanels;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
